import React, { Component } from 'react';
import PropTypes, { any } from 'prop-types';
import PrimaryButton from 'Components/Button/PrimaryButton';
import Button from 'Components/Button/Button';
import DaysLeftCalendar from 'Components/DaysLeftCalendar/DaysLeftCalendar';
import moment from 'moment';
import SelectInputCombo from 'Components/SelectInputCombo/SelectInputCombo';
import { getTranslations, getActionPaneData, getAttachArray } from './configStructure';
import classnames from 'classnames';
import './ActionPane.scss';
import { postActionPaneData, updateActionPaneData } from '../../api/actionPaneApi';
import ResponseBanner from 'Components/cards/ResponseBanner';
import ImagePortal from '../ImagePortal/ImagePortal';
import {
  submitUnresolveTakeAction
} from 'Apis/caseManagerAPI.js';
import { setUnResolvedBannerStatus  } from 'Actions/unResolvedBannerAction';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { connect } from 'react-redux';

import * as KeyConstants from 'Utils/constants/keyConstants.js';
class ActionPane extends Component {
  constructor(props) {
    super(props);

    this.state = {
      jsonHeadings: [],
      translations: [],
      isVisible: props.selectedActionPanelDetailItem !== undefined ? props.selectedActionPanelDetailItem.isVisible : false,
      showComponent: true,
      showText: false,
      textId: 0,
      primaryButtonText: '',
      isActive: false,
      id: 1,
      disabled: true,
      data: {},
      isDataUploaded: false,
      bannerResponseMessage: '',
      isError: false,
      commentText: '',
      selectedCaseNumber: this.props.caseNumber,
      selectedPages: [],
      selectedIndex: 1,
      attachArray: [],
      selectedActionIndex: -1,
      actualSelectedObjectId: -1,
      imageData: [],
      maxIndex: 0,
      respondToIssuerData: [],
      pendDate: '',
      daysLeft: '',
      pendLabel: 'Pend Case Until',
      dateFormat: 'MM/DD/YYYY',
      getReviewPageDescription: [],
      disableCancelButton: false,
      isLoading: false,
    };
    this.attachBindings();
  }

  attachBindings() {
    this.onDisableNextStep = this.onDisableNextStep.bind(this);
    this.buttonClick = this.buttonClick.bind(this);
    this.closeActionPane = this.closeActionPane.bind(this);
    this.onEndEdit = this.onEndEdit.bind(this);
    this.showErrorBanner = this.showErrorBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.forcefulPend = this.forcefulPend.bind(this);
    this.updateSelectedPages = this.updateSelectedPages.bind(this);
    this.attachDocumentPage = this.attachDocumentPage.bind(this);
    this.prePopulateDate = this.prePopulateDate.bind(this);
    this.handleSingleDateChange = this.handleSingleDateChange.bind(this);
    this.resetPendState = this.resetPendState.bind(this);
    this.setPendErrorBanner = this.setPendErrorBanner.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.setCancelResponseBanner = this.setCancelResponseBanner.bind(this);
    this.submitUnresolveTakeAction = this.submitUnresolveTakeAction.bind(this);
  }


  componentWillMount() {
    this.setState({
      jsonHeadings: getActionPaneData(),
      translations: getTranslations(),
      attachArray: getAttachArray(),

    });
    this.prePopulateDate();
  }

  componentDidMount() {

    for (const index in this.state.jsonHeadings) {
      if (this.state.jsonHeadings[index].id == this.props.selectedActionId) {
        this.setState({
          selectedActionIndex: index,
          actualSelectedObjectId: this.state.jsonHeadings[index].id,
        });
        break;
      }
    }
    if (this.props.selectedActionPanelDetailItem !== undefined) {
      this.props.setUnResolvedBannerStatus(true);
      this.setState({ isVisible: this.props.selectedActionPanelDetailItem.isVisible, primaryButtonText: this.props.selectedActionPanelDetailItem.actionPrimaryButtonText, textId: parseInt(this.props.selectedActionId) });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedActionPanelDetailItem !== undefined) {
      this.setState({ isVisible: nextProps.selectedActionPanelDetailItem.isVisible, primaryButtonText: nextProps.selectedActionPanelDetailItem.actionPrimaryButtonText, textId: parseInt(nextProps.selectedActionId) });
    }
    if (this.props.selectedActionId !== nextProps.selectedActionId && this.state.jsonHeadings.length > 0) {
      for (const index in this.state.jsonHeadings) {
        if (this.state.jsonHeadings[index].id == nextProps.selectedActionId) {
          this.setState({
            selectedActionIndex: index,
            maxIndex: this.state.jsonHeadings.length,
            primaryButtonText: nextProps.selectedActionPanelDetailItem.actionPrimaryButtonText,
          });
          break;
        }
      }
    }
  }

  updateSelectedPages(selectedPages) {
    this.setState({
      selectedPages,
    });
  }
  handleSingleDateChange = (id, value) => {
    let newValue;
    const currentDate = new Date();
    let days;
    const valueFound = false;

    if (valueFound === false) {
      newValue = Object.assign(
        {},
        {
          [id]: { d1: moment(value).format('MM/DD/YYYY') },
        },
      );
    }
    const dt1 = new Date(newValue.pendDate.d1);
    days = Math.floor((Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) - Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) / (1000 * 60 * 60 * 24));
    this.setState({
      pendDate: newValue.pendDate.d1,
      daysLeft: days,
    });
  };

  prePopulateDate = () => {
    const today = new Date();
    const requiredDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 5);
    this.setState({
      pendDate: moment(requiredDate).format('MM/DD/YYYY'),
      daysLeft: 5,
    });
  }

  buttonClick(id) {

    const mainContent = document.getElementsByClassName('main-content');
    mainContent[0].scrollTop = 0;

    this.setState({
      showComponent: true,
      showText: true,
      textId: id - 1,
      id,
      selectedIndex: id,
    });
  }

  closeActionPane = () => {
    const actionPanelData = getActionPaneData();
    
    this.prePopulateDate();
    this.props.setUnResolvedBannerStatus(false);
    this.setState({
      isVisible: false,
      isCancelWarning: false,
      primaryButtonText: actionPanelData[0].primaryButtonText,
      cancelButtonText: actionPanelData[0].cancelButtonText,
      jsonHeadings: actionPanelData,
      translations: getTranslations(),
      attachArray: getAttachArray(),
    });
    this.props.resetActionPane();
  }


  onDisableNextStep(flag) {
    this.setState({ disabled: flag });
  }

  clearFilters = () => {
    this.setState({
      currentValues: {},
    });
  }

  onKeyPress(event) {
    const eventCode = event.code + "_" + event.ctrlKey;
    switch (eventCode) {
      case KeyConstants.ESCAPE_BUTTON:
        event.preventDefault();
        this.closeActionPane();
        break;
      //Exit action with validation banner
/*       case KeyConstants.CTRL_RIGHTARROW:
        if (!this.state.disabled) {
          this.submitActionForm(this.props.selectedActionPanelDetailItem);
        }
        event.preventDefault();
        //Go to Prev Step[With validation if available]
        break; */
    }

  }

  setInputForRespondToIssuer(commentType, note, caseNumber) {
    switch (this.state.selectedIndex) {
      case 2:
        return {
          isRepresentmentComment: commentType.value,
          commentText: note,
          caseNumber,
          caseStageId: this.props.caseStageId,
        };
      case 3:
        return {
          isLetterTemplateComment: commentType.value,
          letterMessage: note,
          caseNumber,
          caseStageId: this.props.caseStageId,
        };
    }
  }
  onEndEdit(commentType, note, id, caseNumber) {
    if (id == 8) {
      this.setState({
        selectedCaseNumber: caseNumber,
        data: {
          isExternalComment: commentType.value,
          commentText: note,
          caseNumber,
          caseStageId: this.props.caseStageId,
        },
      });
    } if (id == 7) {
      this.setState({
        selectedCaseNumber: caseNumber,
        data: {
          externalComment: commentType.value,
          commentText: note,
          userId: this.props.userId,// 'Test User', // Need to update when user info is available
        },
      });
    }
    if (id == 6) {
      this.setState({
        data: {
          caseStageId: this.props.caseStageId,
          pendUntilDate: this.state.pendDate,
          isExternalNote: commentType.value,
          note,
          pendIndicator: true,
          forcefulUpdate: false,
          casePendBy: this.props.userId, // Need to update when user info is available
          caseUnpendBy: this.props.userId, // Need to update when user info is available
          isManualTakeAction: true,
        },
      });
    }
  }


  forcefulPend() {
    this.onDisableNextStep(false);
    this.setState({
      disableCancelButton: false,
      isWarning: false,
      isVisible: true,
      data: {
        caseStageId: this.props.caseStageId,
        pendUntilDate: this.state.pendDate,
        isExternalNote: this.state.data.isExternalNote,
        note: this.state.data.note,
        pendIndicator: true,
        forcefulUpdate: true,
        casePendBy: this.props.userId, // Need to update when user info is available
        caseUnpendBy: this.props.userId, // Need to update when user info is available
        isManualTakeAction: true,
      },
    });
    updateActionPaneData(this.state.data, this.props.selectedActionPanelDetailItem.url).then((res) => {
      if (res.status.statusCode == 2004 && res.data == true) {
        this.setState({
          isVisible: false,
        });
        this.props.resetCaseData(this.props.caseNumber);
        this.props.resetActionPane();
        this.setPendSuccessBanner();
      }
    }).catch((res) => {
      this.setState({
        bannerResponseMessage: 'Case pend operation failed for the case number :',
        isDataUploaded: false,
        isError: true,
        commentText: '',
      });
    });
  }
  resetPendState() {
    this.onDisableNextStep(false);
    this.props.closeNotification();
    if (this.state.data.forcefulUpdate) {
      this.setState({
        disableCancelButton: false,
        isWarning: false,
        data: {
          caseStageId: this.props.caseStageId,
          pendUntilDate: this.state.pendDate,
          isExternalNote: this.state.data.isExternalNote,
          note: this.state.data.note,
          pendIndicator: true,
          forcefulUpdate: false,
          casePendBy: this.props.userId, // Need to update when user info is available
          caseUnpendBy: this.props.userId, // Need to update when user info is available
          isManualTakeAction: true,
        },
      });
    }
  }
  setAddNoteBanner() {
    this.props.setNotification([{
      title: 'Success',
      titleStyle: "color: 'light-green'",
      description: this.state.bannerResponseMessage,
      descriptionStyle: "color: 'grey'",
      type: 'success',
      cancelButtonText: 'DISMISS',
      primaryButtonText: 'OKAY, GREAT!',
      isSecondaryButton: 'DISMISS',
      isSecondaryButtonActive: true,
      primaryButtonActionValue: this.props.caseNumber,
      valueStyle: "color: 'black'",
      closeNotification: this.props.closeNotification,
      primaryButtonAction: this.props.closeNotification,
      secondaryButtonAction: this.props.closeNotification,

    }]);
  }
  setPendSuccessBanner() {
    this.props.setNotification([{
      title: 'Case Pended Successfully',
      titleStyle: "color: 'light-green'",
      description: 'Case has been pended till date:',
      descriptionStyle: "color: 'grey'",
      type: 'success',
      cancelOnly: true,
      cancelButtonText: 'CLOSE',
      primaryButtonActionValue: this.state.pendDate,
      valueStyle: "color: 'black'",
      closeNotification: this.props.closeNotification,
      primaryButtonAction: this.props.closeNotification,
      secondaryButtonAction: this.props.closeNotification,
    }]);
  }

    submitUnresolveTakeAction() {
    this.setState({
      isUnresolveRTI: false,
    });
    submitUnresolveTakeAction(this.props.caseNumber,this.props.caseStageId,this.state.data.commentText, this.props.productivityActivityLogId, this.props.caseStage, this.props.card_brand_code, this.props.recordTypeIdentifier).then((res) => {
      if (res == 412 || res  == 400) {
        this.setState({
          isInvalidStageError: true,
          isDataUploaded: false,
          commentText: '',
          isLoading: false,
          disabled: false,
          disableCancelButton: false,
          isWarning: false,
        });
      } else if (res.status.statusCode == 2000 || res.status.statusCode == 200) {
        this.setState({
          isRTIComplete: true,
          isDataUploaded: true,
          isError: false,
          commentText: '',
          isVisible: false,
          isLoading: false,
          disabled: false,
          disableCancelButton: false,
          isWarning: false,
        });
      }
    }).catch((res) => {
      this.setState({
        isDataUploaded: false,
        isRTIError: true,
        commentText: '',
        isLoading: false,
        disabled: false,
        disableCancelButton: false,
        isWarning: false,
      });
    });

  }

  submitActionForm(selectedActionPanelDetailItem) {
    this.setState({
      isLoading: true,
      disabled: true,
      disableCancelButton: true,
      isWarning: false,
    }, () => {
      selectedActionPanelDetailItem.actionType !== 'UNRESOLVEDRTI' && this.props.getSubmitActionStatus(true);
    })
    switch (selectedActionPanelDetailItem.actionType) {
      case 'UNRESOLVEDRTI':
        this.setState({
          isUnresolveRTI: true,
        }, () => { this.showWarningBanner() });
        break;
      case 'ADDNOTE':
        postActionPaneData(this.state.data, selectedActionPanelDetailItem.url).then((res) => {
          if (res.status.statusCode == 2000 || res.status.statusCode == 200) {
            this.setState({
              bannerResponseMessage: 'Add note operation successful for the case number :',
              isDataUploaded: true,
              isError: false,
              commentText: '',
              isVisible: false,
              isLoading: false,
              disabled: false,
              disableCancelButton: false,
              isWarning: false,
            }, () => {
              this.props.getSubmitActionStatus(false);
              this.props.resetActionPane();
              this.props.resetCaseData(this.props.caseNumber);
              this.setAddNoteBanner();
            });
          }
        }).catch((res) => {
          this.setState({
            bannerResponseMessage: 'Add note operation failed for the case number :',
            isDataUploaded: false,
            isError: true,
            commentText: '',
            isLoading: false,
            disabled: false,
            disableCancelButton: false,
            isWarning: false,
          }, () => {
            this.props.getSubmitActionStatus(false);
          });
        });
        break;
      case 'CLOSECASE':
        updateActionPaneData(this.state.data, selectedActionPanelDetailItem.url + this.props.caseNumber).then((res) => {
          if (res.status.statusCode == 2000) {
            this.setState({
              bannerResponseMessage: 'Close case operation successful for the case number :',
              isDataUploaded: true,
              isError: false,
              commentText: '',
              isVisible: false,
              isLoading: false,
              disabled: false,
              disableCancelButton: false,
              isWarning: false,
            }, () => {
              this.props.getSubmitActionStatus(false);
              this.props.setCaseStatus('Close');
              this.props.resetCaseData(this.props.caseNumber);
              this.props.resetActionPane();
              this.setAddNoteBanner();
            });
          }
        }).catch((res) => {
          if (res.response.status == 4000 || res.response.status == 400) {
            this.setState({
              bannerResponseMessage: 'This Case is already closed :',
              isDataUploaded: false,
              isError: true,
              commentText: '',
              isVisible: true,
              isLoading: false,
              disabled: false,
              disableCancelButton: false,
              isWarning: false,
            }, () => {
              this.props.getSubmitActionStatus(false);
            });
          } else {
            this.setState({
              bannerResponseMessage: 'Close case operation failed for the case number :',
              isDataUploaded: false,
              isError: true,
              commentText: '',
              isVisible: true,
              isLoading: false,
              disabled: false,
              disableCancelButton: false,
              isWarning: false,
            }, () => {
              this.props.getSubmitActionStatus(false);
            });
          }
        });
        break;
      case 'PENDCASE':
        updateActionPaneData(this.state.data, selectedActionPanelDetailItem.url).then((res) => {
          if (res.status.statusCode == 2004 && res.data == true) {
            this.setState({
              bannerResponseMessage: 'Case has been pended till date: ',
              isDataUploaded: true,
              isError: false,
              commentText: '',
              isWarning: false,
              isVisible: false,
              isLoading: false,
              disabled: false,
              disableCancelButton: false,
            }, () => {
              this.props.getSubmitActionStatus(false);
              this.props.resetActionPane();
              this.props.resetCaseData(this.props.caseNumber);
              this.setPendSuccessBanner();
            });
          }
          if (res.status.statusCode == 2007 && res.data == false) {
            this.setState({
              bannerResponseMessage: 'Do you still want to proceed?',
              isDataUploaded: false,
              isError: false,
              commentText: '',
              isWarning: true,
              isVisible: true,
              isLoading: false,
              disabled: false,
              data: {
                caseStageId: this.props.caseStageId,
                pendUntilDate: this.state.pendDate,
                isExternalNote: this.state.data.isExternalNote,
                note: this.state.data.note,
                pendIndicator: true,
                forcefulUpdate: true,
                casePendBy: this.props.userId, // Need to update when user info is available
                caseUnpendBy: this.props.userId, // Need to update when user info is available
                isManualTakeAction: true,
              },
              disableCancelButton: true,
            }, () => {
              this.props.getSubmitActionStatus(false);
              this.onDisableNextStep(true);
            });
          }
        }).catch((res) => {
          this.setState({
            bannerResponseMessage: 'Case pend operation failed for case number:',
            isDataUploaded: false,
            isError: true,
            isVisible: true,
            commentText: '',
            isLoading: false,
            disabled: false,
            disableCancelButton: false,
          }, () => {
            this.props.getSubmitActionStatus(false);
          });
        });
        break;
    }
  }
  closeBanner() {
    this.setState({
      isError: false,
      isDataUploaded: false,
      isLoading: false,
      disabled: false,
      disableCancelButton: false,
      isCancelWarning: false,
      isUnresolveRTI: false,
    }, () => {
      this.props.getSubmitActionStatus(false);
    });
  }
  showBanner = () => {
    if (this.state.isRTIComplete) {
      return (
        <div>
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Success"
              description={`Dispute ${this.props.caseNumber} has been unresolved successfully.`}
              type="success"
              successOnly={true}
              primaryButtonText="CLOSE"
              onClose={this.reLoadFullPage}
              primaryButtonAction={this.reLoadFullPage}
            />
          </ImagePortal>
        </div>
      );
    }
  }
  showWarningBanner() {
    if (this.state.isCancelWarning) {
      return (
        <div>
        <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            description="You will lose all progress you have made."
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Are you Sure you Want to Cancel?"
            type="warning"
            onClose={this.closeBanner}
            cancelButtonText="DO NOT CANCEL"
            secondaryButtonAction={this.closeBanner}
            primaryButtonText="YES, PLEASE CANCEL"
            primaryButtonAction={this.closeActionPane}
          />
          </ImagePortal>
        </div>
      );
    }
    if (this.state.isUnresolveRTI) {
      return (
        <div>
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Are you sure if you want to unresolve the case."
              description=""
              type="warning"
              successOnly={true}
              onClose={this.closeBanner}
              primaryButtonText="OKAY"
              primaryButtonAction={this.submitUnresolveTakeAction}
            />
          </ImagePortal>
        </div>
      );
    }
  }
  setPendErrorBanner() {
    if (this.state.isWarning) {
      return (
        <div>
        <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Pend Date Exceeds Card Brand Timeframe"
            description={this.state.bannerResponseMessage}
            type="danger"
            isPrimarSecondaryButtonCombo
            onClose={this.resetPendState}
            cancelButtonText="YES, PROCEED ANYWAY"
            primaryButtonText="NO, PICK ANOTHER DATE"
            primaryButtonActionValue=""
            primaryButtonAction={this.resetPendState}
            secondaryButtonAction={this.forcefulPend}
          />
          </ImagePortal>
        </div>
      );
    }
  }
  showErrorBanner() {
    if (this.state.isError) {
      return (
        <div>
        <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title="Error Occured"
            description={this.state.bannerResponseMessage}
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText="DISMISS"
            primaryButtonActionValue={this.state.selectedCaseNumber}
            primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
            primaryButtonAction={this.closeBanner}
          />
          </ImagePortal>
        </div>
      );
    }
    if (this.state.isInvalidStageError) {
      return (
        <div>
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Error Occured"
              description="Unable to unresolved dispute due to downstream processing. Please contact the support for more details."
              type="danger"
              onClose={this.reLoadFullPage}
              cancelOnly={true}
              cancelButtonText="OKAY"
              primaryButtonAction={this.reLoadFullPage}
            />
          </ImagePortal>
        </div>
      );
    }
    if (this.state.isRTIError) {
      return (
        <div>
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Error Occured"
              description="Unable to unresolved dispute due to downstream processing. Please contact the support for more details."
              type="danger"
              onClose={this.reLoadFullPage}
              cancelOnly={true}
              cancelButtonText="OKAY"
              primaryButtonAction={this.reLoadFullPage}
            />
          </ImagePortal>
        </div>
      );
    }
  }

  reLoadFullPage = () => {
    window.location.reload();
  }

  attachDocumentPage(selectedId, operation) {
    switch (operation) {
      case 'push':
        const arr = Object.assign([], this.state.jsonHeadings);
        for (const index in this.state.attachArray) {
          if (this.state.attachArray[index].attachType == this.state.jsonHeadings[selectedId - 1].attachType) {
            arr.splice(selectedId, 0, this.state.attachArray[index]);
          }
        }
        this.setState({
          jsonHeadings: arr,
          maxIndex: arr.length,
        });
        break;
      case 'pop':
        const popArray = Object.assign([], this.state.jsonHeadings);
        popArray.splice(selectedId, 1);
        this.setState({
          jsonHeadings: popArray,
          maxIndex: popArray.length,
        });
        break;
    }
  }
  setCancelResponseBanner() {
    this.setState({
      isCancelWarning: true,
    });
  }

  render() {
    const wrapperClass = classnames('action-pane', {
      unresolveRti: this.state.isVisible && this.props.selectedActionPanelDetailItem.actionType === 'UNRESOLVEDRTI',
      hidden: !this.state.isVisible,
      show: this.state.isVisible && this.props.selectedActionPanelDetailItem.actionType !== 'UNRESOLVEDRTI',
    });
    const isLoading = this.state.isLoading;

    return (
      <div id="ActionPane" className={!isLoading ? wrapperClass : wrapperClass + ' opacity'} >
        {this.showErrorBanner()}
        {this.setPendErrorBanner()}
        {this.showWarningBanner()}
        {this.showBanner()}
        <ul className="button-style" style={{paddingTop:55}}>
          <li>
            {
              <div className="control-content" style={this.props.selectedActionPanelDetailItem.extraStyle}>
                <div className="headings">
                  {this.state.jsonHeadings[this.state.selectedActionIndex] !== undefined && this.state.jsonHeadings[this.state.selectedActionIndex].title !== undefined && <div className="headings-fixed"> {this.state.jsonHeadings[this.state.selectedActionIndex].title}</div>}
                  {this.state.jsonHeadings[this.state.selectedActionIndex] !== undefined && <div className="headings-change">{(this.props.unresolvedRTIAction !== undefined && this.props.unresolvedRTIAction) ? 'Add Reason For Unresolve' : this.state.jsonHeadings[this.state.selectedActionIndex].description}</div>}
                </div>
                {this.state.jsonHeadings[this.state.selectedActionIndex] !== undefined && this.state.jsonHeadings[this.state.selectedActionIndex].info !== undefined && <div style={{ fontSize: 14, fontWeight: 600, fontColor: '#595959', whiteSpace: 'pre-wrap', width: 260, paddingLeft: 15, paddingTop: 11 }}>{this.state.jsonHeadings[this.state.selectedActionIndex].info}</div>}
              </div>

            }
          </li>
          <li>
            {isLoading && <div className="actionLoader"><BVLoader20 /></div>}
            <div className={this.state.selectedActionIndex == 6 ? 'dynamic-content-pend' : 'dynamic-content'}>
              {this.state.selectedIndex === 1 && this.state.selectedActionIndex == 6 && <DaysLeftCalendar
                handleSingleDateChange={this.handleSingleDateChange}
                prePopulateDate={this.prePopulateDate}
                pendDate={this.state.pendDate}
                daysLeft={this.state.daysLeft}
                labelDescription={this.state.pendLabel}
                dateFormat={this.state.dateFormat}
              />
              }
              {this.state.showComponent && this.props.selectedActionPanelDetailItem !== undefined &&
                <SelectInputCombo
                  id={this.state.selectedActionIndex == 0 ? this.state.selectedIndex - 1 : this.state.selectedActionIndex}
                  jsonHeadings={this.state.jsonHeadings}
                  onDisableNextStep={this.onDisableNextStep}
                  style={{ float: 'right' }}
                  selectionList={this.props.selectedActionPanelDetailItem.actionSelectionList}
                  onEndEdit={this.onEndEdit}
                  caseNumber={this.props.caseNumber}
                  isDataUploaded={this.props.isDataUploaded}
                  isError={this.state.isError}
                  selectedIndex={this.state.selectedIndex}
                  attachDocumentPage={this.attachDocumentPage}
                  actualSelectedObjectId={this.props.selectedActionId}
                  imageContents={this.state.imageContents}
                />}

            </div>
          </li>
        </ul>


        <div className="action-pane__footer" >

          <Button
            action={this.setCancelResponseBanner}
            extraClass="clear clear-button"
            category="link-inline"
            id={'1_btn_clear'}
            disabled={this.state.disableCancelButton}
          >
            <strong> {this.state.translations.cancel}</strong>
          </Button>
          <div className="action-pane__footer-right" >
            <PrimaryButton
              action={() => { this.submitActionForm(this.props.selectedActionPanelDetailItem); }}
             extraClass={`next-step-button ${
    this.props.unresolvedRTIAction ? '' : this.state.disabled ? 'is-disabled' : ''
  }`}
              id={'1_btn_apply'}
              style={{ width: 125, height: 100 + '%' }}
              disabled={this.props.unresolvedRTIAction ? false : this.state.disabled}
            >
              <strong>{this.state.primaryButtonText}</strong>
            </PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

ActionPane.propTypes = {
  isVisible: PropTypes.bool,
  closeNotification: PropTypes.func,
  cancelOnly: PropTypes.bool,
  isSearchActive: PropTypes.bool,
};

ActionPane.defaultProps = {
  isVisible: false,

};

const mapStateToProps = (state) => ({
  isSearchActive: state.appSearch.isSearchActive,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUnResolvedBannerStatus: (unResolvedBannerStatus) => {
      dispatch(setUnResolvedBannerStatus(unResolvedBannerStatus));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionPane);
